<template>
  <div style="margin-top: -12px">
    <v-container fluid>
      <v-row>
        <v-col>
          <v-card elevation="0" color="#e91e6312">
            <v-card-text>
              <v-list-item three-line>
                <v-list-item-content>
                  <div
                    class="overline mb-4 font-weight-bold blue-grey--text"
                    style="font-size: 11px !important;"
                  >
                    <v-btn
                      class="ma-2 mt-4 font-weight-bold blue-grey--text"
                      style="font-size: 11px !important;"
                      text
                      @click="gotToOpened"
                      >Facturas Abertas</v-btn
                    >
                  </div>
                </v-list-item-content>
                <v-progress-circular
                  v-for="count in getInvoiceStatusInStore"
                  v-show="count.status === 'a'"
                  :key="count.count"
                  :value="count.count"
                  :rotate="-90"
                  :size="100"
                  :width="15"
                  color="#1976d2c4"
                >
                  <span style="font-size: 20px">{{ count.count }}</span>
                </v-progress-circular>
              </v-list-item>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col>
          <v-card elevation="0" color="#1ee9d217">
            <v-card-text>
              <v-list-item three-line>
                <v-list-item-content>
                  <div
                    class="overline mb-4 font-weight-bold blue-grey--text"
                    style="font-size: 11px !important;"
                  >
                    <v-btn
                      class="ma-2 font-weight-bold blue-grey--text mt-4"
                      style="font-size: 11px !important;"
                      text
                      @click="goToClosed"
                      >Facturas Fechadas</v-btn
                    >
                  </div>
                </v-list-item-content>
                <v-progress-circular
                  v-for="count in getInvoiceStatusInStore"
                  v-show="count.status === 'p'"
                  :key="count.count"
                  :value="count.count"
                  :rotate="-90"
                  :size="100"
                  :width="15"
                  color="#1976d2c4"
                >
                  <span style="font-size: 20px">{{ count.count }}</span>
                </v-progress-circular>
              </v-list-item>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col>
          <v-card elevation="0" color="#bbe91e17">
            <v-card-text>
              <v-list-item three-line>
                <v-list-item-content>
                  <div
                    class="overline mb-4 font-weight-bold blue-grey--text"
                    style="font-size: 11px !important;"
                  >
                    <v-btn
                      class="ma-2 font-weight-bold blue-grey--text mt-4"
                      style="font-size: 11px !important;"
                      text
                      @click="goToAnalyze"
                      >Facturas em análise</v-btn
                    >
                  </div>
                </v-list-item-content>
                <v-progress-circular
                  v-for="count in getInvoiceStatusInStore"
                  v-show="count.status === 'a'"
                  :key="count.count"
                  :value="count.count"
                  :rotate="-90"
                  :size="100"
                  :width="15"
                  color="#1976d2c4"
                >
                  <span style="font-size: 20px">{{ count.count }}</span>
                </v-progress-circular>
              </v-list-item>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapHelperEnterprise } from "@/store/helperEnterprise";
export default {
  name: "CardsInvoice",
  methods: {
    gotToOpened() {
      this.$router.push("/invoices/unpaid");
    },
    goToClosed() {
      this.$router.push("/invoices/paid");
    },
    goToAnalyze() {
      this.$router.push("/invoices/analyze");
    },

    numberunpaid() {}
  },
  computed: {
    ...mapHelperEnterprise
  }
};
</script>

<style scoped></style>
